import { createElement } from 'react';
import PropTypes from 'prop-types';

import { withTracker, hitTypes } from 'helpers/tracking';
import Link from 'components/Link';
import { getFavoritesUrl } from 'helpers/namedUrls';
import FavoriteAdded from '../icons/FavoriteAdded.com.svg';
import FavoriteRemoved from '../icons/FavoriteRemoved.com.svg';
import DislikeAdNotification from './DislikeAdNotification';
import CopyToClipboardNotification from './CopyToClipboardNotification';

import cn from './styles.local.less';

const REMOVE_FAVORITE = 'unfavorite';
const ADD_FAVORITE = 'favorite';

const translationKeys = {
  [ADD_FAVORITE]: __('favorites.addedNotification'),
  [REMOVE_FAVORITE]: __('favorites.removedNotification'),
};

function FavoriteNotification({ adTitle, tracker, type }) {
  const translatedText = translationKeys[type];
  const newEl = translatedText.replace(/\{(\w+)\}/g, `<b>${adTitle}</b>`);

  return (
    <div className={cn.root}>
      {type === ADD_FAVORITE ? <FavoriteAdded className={cn.icon} /> : null}
      {type === REMOVE_FAVORITE ? (
        <FavoriteRemoved className={cn.icon} />
      ) : null}
      <div className={cn.notificationText}>
        <span dangerouslySetInnerHTML={{ __html: newEl }} />
        {type === ADD_FAVORITE ? (
          <Link
            to={getFavoritesUrl()}
            rel="nofollow"
            className={cn.link}
            onClick={() => {
              tracker.track(
                hitTypes.FAVORITE_NOTIFICATION_OVERVIEW_LINK_CLICK,
                {},
              );
            }}
          >
            {__('favorites.notification.goToFavoriteLink')}
          </Link>
        ) : null}
      </div>
    </div>
  );
}

FavoriteNotification.propTypes = {
  adTitle: PropTypes.string,
  type: PropTypes.string,
  tracker: PropTypes.object,
};

const FavoriteNotificationWithTracker = withTracker(FavoriteNotification);

export const createFavoriteRemovedNotifierComponent = (adTitle) =>
  createElement(FavoriteNotificationWithTracker, {
    ...adTitle,
    type: REMOVE_FAVORITE,
  });

export const createFavoriteAddedNotifierComponent = (adTitle) =>
  createElement(FavoriteNotificationWithTracker, {
    ...adTitle,
    type: ADD_FAVORITE,
  });

export const createDislikeAdNotificationComponent = (props) =>
  createElement(DislikeAdNotification, {
    ...props,
    type: 'ADD',
  });

export const createDislikeAdRemovalNotificationComponent = (props) =>
  createElement(DislikeAdNotification, {
    ...props,
    type: 'REMOVE',
  });

export const createCopyToClipboardNotificationComponent = (props) =>
  createElement(CopyToClipboardNotification, props);
